module.exports = __webpack_public_path__ + "static/media/masjid_kichula4.833a226d.webp";